/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of an account deletion task we can search for
 * @export
 */
export const AccountDeletionTaskSearchStatus = {
    Scheduled: 'SCHEDULED',
    InProgress: 'IN_PROGRESS',
    Canceled: 'CANCELED',
    Completed: 'COMPLETED'
} as const;
export type AccountDeletionTaskSearchStatus = typeof AccountDeletionTaskSearchStatus[keyof typeof AccountDeletionTaskSearchStatus];


export function instanceOfAccountDeletionTaskSearchStatus(value: any): boolean {
    for (const key in AccountDeletionTaskSearchStatus) {
        if (Object.prototype.hasOwnProperty.call(AccountDeletionTaskSearchStatus, key)) {
            // @ts-ignore
            if (AccountDeletionTaskSearchStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountDeletionTaskSearchStatusFromJSON(json: any): AccountDeletionTaskSearchStatus {
    return AccountDeletionTaskSearchStatusFromJSONTyped(json, false);
}

export function AccountDeletionTaskSearchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTaskSearchStatus {
    return json as AccountDeletionTaskSearchStatus;
}

export function AccountDeletionTaskSearchStatusToJSON(value?: AccountDeletionTaskSearchStatus | null): any {
    return value as any;
}

